/*
    Copyright 2022 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

// this is autogenerated file, see scripts/gen-version.js
export const VERSIONS = {
	pkgVersion: "1.337.2",
	prereleaseTag: "20260403-051644",
	fullVersion: "1.337.2.20260403-051644",
	buildDate: "2026.04.03 05:16:44",
	commitHash: "fd5b43ad0ad51e6d58afdb3950b6cef62a0f804a",
	isDevVersion: false
};
